<div class="flex overflow-y-auto h-screen justify-content-center">
  <div class="w-full md:max-w-main-container">
    <div class="flex flex-column md:flex-row secondary">
      <div class="layout-main-container w-full min-h-screen md:border-1 md:surface-border p-2 pb-6">
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="flex w-full md:max-w-main-container justify-content-center align-items-center fixed bottom-0 fixed bottom-0 layout-main-container">
      <img [src]="srcLogo" class="flex h-3rem cursor-pointer">
    </div>
  </div>
</div>


